// Styles
import link_styles from "./link_styles";

function Link({ link, link_text }: { link?: string; link_text?: string }) {
  if (!link) return null;

  return (
    <div style={link_styles.link_container}>
      <a style={link_styles.link} href={link}>
        {link_text}
      </a>
    </div>
  );
}

export default Link;